import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCardMakeMaterialList } from '@/views/salesCardManagement/api';
export default {
  name: 'AddMaterialDialog',
  props: {
    // 上个页面传过来的物料参数（{ print_type, batch }）
    addMaterialParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    // 父组件已有的物料 id 列表（用于去重，过滤掉已选过的物料）
    existingMaterialIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visibleAddMaterial: false,
      form: {
        type: '2',
        id: '',
        name: '',
        material_type: [],
        print_type: '',
        batch: '',
        page: 1,
        pagesize: 20
      },
      // 基础物料类型
      baseMaterialTypeList: [{
        value: '3',
        label: '卡套'
      }, {
        value: '4',
        label: '券套'
      }, {
        value: '5',
        label: '手提袋'
      }, {
        value: '6',
        label: '宣传册'
      }, {
        value: '7',
        label: '画册'
      }, {
        value: '8',
        label: '其他'
      }],
      dataList: [],
      pages: {},
      selection: [],
      // 分公司/仓库下拉（来自物料列表接口的 branch_office_select，去重合并）
      branchOfficeSelect: [],
      is_make_card: false,
      // true 的话,代表是从制卡列表过来的
      // is_make_card 场景下，父组件已添加的 PVC卡/券 material_type 集合
      existingCardCouponTypes: []
    };
  },
  computed: {
    // 物料类型下拉数据，按 value 去重，避免重复选项
    materialTypeList: function materialTypeList() {
      var list = _toConsumableArray(this.baseMaterialTypeList);
      // is_make_card 为 true 时追加 PVC卡、券
      if (this.is_make_card) {
        list = [].concat(_toConsumableArray(list), [{
          value: '1',
          label: 'PVC卡'
        }, {
          value: '2',
          label: '券'
        }]);
      }
      var seen = new Set();
      return list.filter(function (item) {
        if (seen.has(item.value)) return false;
        seen.add(item.value);
        return true;
      });
    },
    // 过滤掉父组件已选过的物料，避免重复添加
    filterDataList: function filterDataList() {
      var ids = (this.existingMaterialIds || []).map(String);
      if (!ids.length) return this.dataList;
      return (this.dataList || []).filter(function (item) {
        return !ids.includes(String(item.id));
      });
    }
  },
  methods: {
    // 从 addMaterialParams 同步到 form
    syncFormFromProps: function syncFormFromProps() {
      var _ref = this.addMaterialParams || {},
        batch = _ref.batch,
        print_type = _ref.print_type;
      this.form.type = batch ? '0' : '2';
      this.form.batch = batch || '';
      // 印刷类型由上个页面传入，直接使用 prop 的值
      this.form.print_type = print_type ? String(print_type) : '';
    },
    getList: function getList() {
      var _this = this;
      var params = _objectSpread({}, this.form);
      getCardMakeMaterialList(params).then(function (res) {
        _this.dataList = res.data.list || [];
        _this.pages = res.pages || {};
      });
    },
    search: function search() {
      this.form.page = 1;
      this.getList();
    },
    reset: function reset() {
      this.$refs.form.resetFields();
      this.form.material_type = [];
      // 重置时保留父组件传入的印刷类型 / batch / type
      this.syncFormFromProps();
      this.search();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selection = val;
    },
    handleConfirm: function handleConfirm() {
      if (!this.selection.length) {
        this.$message.warning('请至少选择一个物料');
        return;
      }
      // 过滤掉父组件已选过的物料，传回主页面的就是"真正新增"的数据
      var existingIds = (this.existingMaterialIds || []).map(String);
      var toAdd = this.selection.filter(function (item) {
        return !existingIds.includes(String(item.material_id));
      });
      if (!toAdd.length) {
        this.$message.warning('所选物料均已添加，请重新选择');
        return;
      }
      // 制卡场景下，PVC卡(1)/券(2) 全局只能存在1种类型且最多1条
      if (this.is_make_card) {
        var newCardCoupon = toAdd.filter(function (item) {
          return String(item.material_type) === '1' || String(item.material_type) === '2';
        });
        if (newCardCoupon.length > 1) {
          this.$message.warning('PVC卡/券类型每次只能添加1种');
          return;
        }
        if (newCardCoupon.length === 1) {
          // 检查父组件已添加的 PVC卡/券 类型
          if (this.existingCardCouponTypes.length > 0) {
            this.$message.warning("\u5DF2\u5B58\u5728".concat(this.existingCardCouponTypes.map(function (t) {
              return t === '1' ? 'PVC卡' : '券';
            }).join('、'), ",\u4E0D\u53EF\u91CD\u590D\u6DFB\u52A0"));
            return;
          }
        }
      }
      this.$emit('submit', toAdd);
      this.handleClose();
    },
    handleClose: function handleClose() {
      this.visibleAddMaterial = false;
      this.dataList = [];
    },
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getList();
    },
    sizeChange: function sizeChange(val) {
      this.form.pagesize = val;
      this.form.page = 1;
      this.getList();
    }
  }
};